<template>
  <div class="gameorderRapper">
    <header>
      <div>
        <img src="~assets/images/game/return.png" alt @click="returnpage" />
      </div>
      <span>新游预约</span>
      <div></div>
    </header>
    <div class="content">
      <h2>即将开测</h2>
      <div class="testSoon">
        <div class="swiperCon">
          <div 
            class="swiperSlide"
            v-for="(item, ind) in testList"
            :key="ind"
          >
            <div
              @click="enterDetails(item,ind)"
            >
              <div class="swiperScript">
                <p>{{item.onlineDate|handleTestTime}}</p>
                <p>{{item.displayLanguage}}</p>
                <div class="circle" :class="{circleActive:(item.onlineDate|handleTestTime == '已开测')}"></div>
              </div>
              <div class="imgCon">
                <img v-lazy="item.gameIconUrl" :key="item.gameIconUrl" alt />
                <p>{{item.gameName}}</p>
              </div>
            </div>
            <div :class="item.button=='已预约'?'button ordered':'button order'" @click="showmask($event,item.gameId)" :ref="item.gameId">{{item.button}}</div>
          </div>
        </div>
      </div>
      <h2 class="order">预约专区</h2>
      <div class="areaCon">
        <goodGames :orderList="orderList"></goodGames>
      </div>
    </div>
    <div class="mask" v-show="isshowtoast">
        <div class="maskbox">
            <p class="order-title">手机号预约</p>
            <span class="close" @click="closemask()">×</span>
            <p class="msg">手机号仅用于接收游戏上线通知</p>
            <input class="phone-text" type="text" placeholder="请输入手机号码" ref="phone">
            <div class="maskbtn" @click="save()">预约</div>
        </div>
    </div>
    <div class="toast" v-show="istoast">{{toastmsg}}</div>
  </div>
</template>

<script>
import goodGames from "@/components/gamebox/goodGames";
import { goBack, androidMethod, gotoServerGameDetail, changeResId } from "@/utils/base";
import config from '@/../config'
export default {
  data() {
    return {
      testList: [],
      orderList: [],
      gameidlist: [],
      isColor: false,
      handleTestTime: "",
      uuid: "",
      isshowtoast: false,//是否展示电话的预约弹框
      istoast: false, //是否展示toast提示
      toastmsg: "预约成功", //提示的文字
      gameId: "",//预约的gameId
      isclick: true,//是否可以点击跳转详情页
      resId: {
          categoryID: 4003,
          gameId: '',
          param1: 0,
          param2: 0,
          paramExtra: '',
          reqId: '',
          source: 1,
      },
      location: '',
    };
  },
  components: {
    goodGames
  },
  filters: {
    handleTestTime(date) {
      var myDate = new Date();
      var array = date.substr(0, 10).split("-");
      var ndate = new Date(array[0], parseInt(array[1] - 1), array[2]);
      var weekArray = [
        "本周日",
        "本周一",
        "本周二",
        "本周三",
        "本周四",
        "本周五",
        "本周六"
      ];
      var weekArray2 = [
        "下周日",
        "下周一",
        "下周二",
        "下周三",
        "下周四",
        "下周五",
        "下周六"
      ];
      var weekDay = weekArray[ndate.getDay()];
      var weekDay2 = weekArray[myDate.getDay()];
      if (ndate > myDate) {
        var dateBetween = parseInt((ndate - myDate) / (1000 * 60 * 60 * 24));
        switch (weekDay2) {
          case "本周日":
            if (dateBetween <= 6) {
              return weekArray2[ndate.getDay()];
            } else {
              return "即将开测";
            }
            break;
          case "本周一":
            if (dateBetween <= 5) {
              return weekArray[ndate.getDay()];
            } else if (dateBetween > 5 && dateBetween <= 12) {
              return weekArray2[ndate.getDay()];
            } else {
              return "即将开测";
            }
            break;
          case "本周二":
            if (dateBetween <= 4) {
              return weekArray[ndate.getDay()];
            } else if (dateBetween > 4 && dateBetween <= 11) {
              return weekArray2[ndate.getDay()];
            } else {
              return "即将开测";
            }
            break;
          case "本周三":
            if (dateBetween <= 3) {
              return weekArray[ndate.getDay()];
            } else if (dateBetween > 3 && dateBetween <= 10) {
              return weekArray2[ndate.getDay()];
            } else {
              return "即将开测";
            }
            break;
          case "本周四":
            if (dateBetween <= 2) {
              return weekArray[ndate.getDay()];
            } else if (dateBetween > 2 && dateBetween <= 9) {
              return weekArray2[ndate.getDay()];
            } else {
              return "即将开测";
            }
            break;
          case "本周五":
            if (dateBetween <= 1) {
              return weekArray[ndate.getDay()];
            } else if (dateBetween > 1 && dateBetween <= 8) {
              return weekArray2[ndate.getDay()];
            } else {
              return "即将开测";
            }
            break;
          case "本周六":
            if (dateBetween <= 0) {
              return weekArray[ndate.getDay()];
            } else if (dateBetween > 0 && dateBetween <= 7) {
              return weekArray2[ndate.getDay()];
            } else {
              return "即将开测";
            }
            break;
        }
      } else {
        return "已开测";
      }
    }
  },
  created() {
    const { location } = this.$route.query;
    this.location = location || '';
    androidMethod('setStatusColor','','1','#fff');
    androidMethod('setStatusMode', '', "true");
    this.uuid = androidMethod('getUserUUID', '');
    this.getorderlist();//获取用户预约的游戏id
  },
  mounted(){
    window['AndroidLifeOnResume'] = () => {
      this.getorderlist()
    }
  },
  methods: {
    // 获取用户预约的游戏id
    getorderlist(){
      this.$http.post(`/apiserv/GameBooking/Frontend/UserBookingState/${this.uuid}`).then(res => {
        if (res.data.return_code == 200) {
          this.gameidlist = res.data.data;
          //请求即将开测的数据
          this.$http.post("/apiserv/GameBooking/Frontend/GameTimeLine").then(res => {
            if (res.data.return_code == 200) {
              var data = res.data.data;
              data.forEach((i,ind) =>{
                var id = this.gameidlist.filter((item) => {
                  return item == i.gameId
                })
                if(id.length != 0){
                  i.button = "已预约";
                }else{
                  i.button = "预约";
                }
              })
              this.testList = data;
            }
          });
          //请求预约专区的数据
          this.$http.post("/apiserv/GameBooking/Frontend/GreatGameList").then(res => {
            if (res.data.return_code == 200) {
              var data = res.data.data;
              data.forEach((i,ind) =>{
                var id = this.gameidlist.filter((item) => {
                  return item == i.gameId
                })
                if(id.length != 0){
                  i.button = "已预约";
                }else{
                  i.button = "预约";
                }
              })
              this.orderList = data;
            }
          });
        }
      });
    },
    returnpage() {
      if (this.location === 'website') {
        window.history.back();
        return;
      }
     goBack();
    },
    enterDetails(game,ind) {
      if(this.isclick){
        this.isclick = false;
        setTimeout(() => {
            this.isclick = true;
        }, 1000);
        if (this.location === 'website') {
          gotoServerGameDetail({ gameId: game.gameId });
          return;
        }
        var versionCode = window.versionCode;
        if (versionCode >= 2400000) {
            const params = {
                ...this.resId,
                param1: ind * 1 + 1,
                gameId: game.gameId,
            };
            collect('item_click', changeResId(params), '预约-web');
            androidMethod('setResId', '', JSON.stringify(params));
            game.id = game.gameId;
            const res = androidMethod('openGameDetail', '', JSON.stringify(game), JSON.stringify(params));
            if (res.code === 404) {
                gotoServerGameDetail({ gameId: game.gameId });
            }
        } else {
            gotoServerGameDetail({ gameId: game.gameId });
        }
      }
      // this.$router.push({
      //   path: "/game/gamedetails",
      //   query: { gameId: gameId }
      // });
      // const p = location.href.split("?");
      // window.location.href = `${config.SERVER_TEMP}/gameserv/GameDetail/detail.html?gameId=${gameId}&${p[1]}`;
    },
    //点击按钮判断是否展示弹框或者toast
    showmask(event,gameId) {
      if (event.target.innerText !== '已预约') {
        collect("event_yuyue_maskshow", {
          gameid: gameId
        });
        this.isshowtoast = true;
        this.$refs.phone.value = localStorage.getItem("phone") ? localStorage.getItem("phone") : "";
        this.gameId = gameId;
      } else {
        this.eventtoast("您已预约成功，敬请期待");
      }
    },
    //展示预约电话的弹框
    closemask(){
      this.isshowtoast = false;
    },
    //请求预约接口
    save(){
      var phone = this.$refs.phone.value;
      if (phone && /^[1][0-9]{10}$/.test(phone)) {
        this.$http.post(`/apiserv/gameBooking/saveBooking?uuid=${this.uuid}&phoneNum=${phone}&gameId=${this.gameId}`).then((res) =>{
          if(res.data.return_code == 200){
            if(res.data.data){
              collect("event_yuyue_success", {
                gameid: this.gameId
              });
              localStorage.setItem("phone", phone);
              this.eventtoast("您已预约成功，敬请期待");
              this.orderList.forEach((i) => {
                if(i.gameId == this.gameId){
                  i.button = "已预约"
                }
              })
              this.testList.forEach((i) =>{
                if(i.gameId == this.gameId){
                  i.button = "已预约"
                }
              })
              this.isshowtoast = false;
            }else {
              this.eventtoast("预约失败");
            }
          }else{
            this.eventtoast(res.return_msg);
          }
        })
      } else {
        this.eventtoast("请输入正确的手机号码");
      }
    },
    //展示toast提示
    eventtoast(msg){
      this.istoast = true;
      this.toastmsg = msg;
      setTimeout(() => {
        this.istoast = false;
      }, 1000);
    }
  }
};
</script>

<style lang='less' scoped>
.gameorderRapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  header {
    height: 0.5rem;
    display: flex;
    padding: 0.166rem;
    > :nth-child(1) {
      flex: 1;
      display: flex;
      align-items: center;
      img {
        width: 0.25rem;
        height: 0.25rem;
        margin-left: -0.05rem;
      }
    }
    > :nth-child(2) {
      flex: 3;
      text-align: center;
      line-height: 0.168rem;
      font-size: 0.19rem;
      font-weight: 400;
      color: rgba(27, 27, 27, 1);
    }
    > :nth-child(3) {
      flex: 1;
    }
  }
  .content {
    flex: 1;
    height: 6.17rem;
    overflow: scroll;
    h2 {
      color: #1b1b1b;
      font-size: 0.17rem;
      font-weight: 500;
      line-height: 0.23rem;
      text-align: left;
      padding-top: 0.17rem;
      padding-left: 0.17rem;
      background: #fff;
    }
    h2.order {
      margin-top: 0.08rem;
    }
    .testSoon {
      width: 3.75rem;
      overflow-x: scroll;
      background: #fff;
      padding-top: 0.17rem;
      text-align: center;
      .swiperCon {
        width: max-content;
        height: 1.74rem;
        text-align: center;
        .swiperSlide {
          width: 0.88rem;
          float: left;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          >div{
            width: 100%;
          }
          p {
            font-weight: 400;
            text-align: center;
          }
          .swiperScript {
            width: 100%;
            padding-bottom: 0.12rem;
            border-bottom: 1px solid #eeeeee;
            position: relative;
            > p:nth-child(1) {
              font-size: 0.13rem;
              color: #333;
              line-height: 0.2rem;
            }
            > p:nth-child(2) {
              font-size: 0.11rem;
              height: .2rem;
              color: #999999;
              line-height: 0.2rem;
            }
            .circle {
              width: 0.06rem;
              height: 0.06rem;
              background: #ccc;
              position: absolute;
              bottom: -0.04rem;
              left: 50%;
              border-radius: 50%;
              margin-left: -0.03rem;
            }
            .circleActive {
              background: #ff4d00;
            }
          }
          .imgCon {
            padding-top: 0.12rem;
            // display: flex;
            // flex-direction: column;
            // justify-content: center;
            // align-items: center;
            img {
              width: 63px;
              height: 61px;
              border-radius: 13px;
              margin-bottom: 0.06rem;
            }
            p {
              width: 100%;
              font-size: 0.14rem;
              color: #333333;
              height: 0.39rem;
              line-height: .39rem;
              line-clamp: 2;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          &:nth-child(1) {
            width: 1rem;
          }
          .button{
            width: .6rem;
            height: .28rem;
            line-height: .28rem;
            font-size: .15rem;
            border-radius: .14rem;
          }
          .order{
            background: #e5f7eb;
            color: #00B83D;
          }
          .ordered{
            background: #CCCCCC;
            color: #fff;
          }
        }
      }
    }
    .areaCon {
      padding: 0.17rem;
      overflow: hidden;
      background: #fff;
    }
  }
}
.mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 20;
}
.maskbox{
    width: 2.64rem;
    height: 1.92rem;
    background: #fff;
    padding: 0.1rem 0.2rem;
    border-radius: 0.12rem;
    position: relative;
    margin-top: 2.3rem;
    margin-left: .48rem;
}
.order-title{
    width: 100%;
    line-height: 0.24rem;
    font-size: 0.17rem;
    font-weight: 600;
    text-align: center;
    color: #333333;
    margin-top: 0.1rem;
    margin-bottom: 0.12rem;
}
.close{
    width: 0.2rem;
    height: 0.2rem;
    position: absolute;
    top: 0.1rem;
    right: 0.1rem;
    font-size: 0.2rem;
    color: #ADADAD;
    line-height: 0.2rem;
}
.msg{
    width: 100%;
    height: 0.16rem;
    line-height: 0.16rem;
    font-size: 0.12rem;
    color:#AEAEAE;
    margin-bottom: 0.08rem;
}
.maskbox input{
    width: 2.24rem;
    height: 0.4rem;
    line-height: 0.4rem;
    padding-left:0.12rem;
    border-radius: 0.06rem;
    border:1px solid #F5F5F5;
    background: #F5F5F5;
    margin-bottom: 0.12rem;
    font-size: 0.15rem;
}
.mask .maskbtn{
    width: 2.24rem;
    height: 0.4rem;
    line-height: 0.4rem;
    border:1px solid #52AEFF;
    background: #52AEFF;
    text-align: center;
    border-radius: 0.06rem;
    color: #fff;
    font-size: 0.16rem;
}
.toast{
    line-height: .3rem;
    font-size: .16rem;
    color: #fff;
    text-align: center;
    width: 2rem;
    position: fixed;
    bottom: .3rem;
    left: 50%;
    margin-left: -1rem;
    border-radius: .05rem;
    background: rgba(0, 0, 0,.7);
    z-index: 22;
}
</style>  